import React, { Component } from "react";
import Chart from "react-apexcharts";

class Chartslline extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: {
        chart: {
          id: "basic-bar",
        },
        xaxis: {
          categories: ["3M", "6M", "1A", "2A", "3A", "4A", "5A", "6A", "7A"],
        },
      },
      series: [
        {
          // name: "Actual",
          // data: this.props.data[0],
          name: "series-1",
          data: [10, 20, 45, 80, 9, 80, 78, 21, 110, 10, 23, 121],
        },
        {
          // name: "Dia Anterior",
          // data: this.props.data[1],
          name: "series-2",
          data: [30, 40, 45, 50, 49, 60, 70, 91, 100, 120, 23, 122],
        },
      ],
    };
  }

  render() {
    return (
      <div>
        <Chart
          options={this.state.options}
          series={this.state.series}
          type="line"
          width="100%"
        />
      </div>
    );
  }
}

export default Chartslline;
